Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
function pauseElementBasedMedia(element) {
  element.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  element.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  element.querySelectorAll('video').forEach((video) => video.pause());
  element.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
if (!customElements.get('smooth-anchor')) {
  customElements.define('smooth-anchor', class SmoothAnchor extends HTMLElement {
    constructor() {
      super();
      
      this.anchor = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
      this.anchor.addEventListener('click', this.onClickRef.bind(this));
    }
    
    onClickRef(){
      event.preventDefault();
      
      const targetId = this.anchor.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      
      if(targetElement){
        if(this.dataset.offset){
          let offset = 0;
          const offsetElement = document.querySelector(this.dataset.offset);
          if(!offsetElement){
            doScroll();
            if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return
          };
          const elementPosition = targetElement.getBoundingClientRect().top;
          offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
          window.scrollTo({
            top: offset,
            behavior: "smooth"
          });
          if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
          return;
        }
        doScroll();
        if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
      }
        
      function doScroll(){
        targetElement.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  });
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
if (!customElements.get('hideable-element')) {
  customElements.define('hideable-element', class HideableElement extends HTMLElement {
    constructor() {
      super();
      this.elementToHide = this.querySelector('aside');
      this.elementToggle = this.querySelector('.js-contents--btn-close');
      const hasBeenHidden = localStorage.getItem(`${this.elementToHide.id}-hidden`);
      
      if (hasBeenHidden) {
        this.elementToHide.classList.add('hidebar');
      }
      
      if(this.elementToggle){
        this.elementToggle.addEventListener('click', () => {
          this.elementToHide.style.display = 'none';
          localStorage.setItem(`${this.elementToHide.id}-hidden`, true);
        });
      }
    }
  });
}
// Countdown_Timer
if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      const endDate = new Date(this.getAttribute('end-date'));
      if (isNaN(endDate)) {
        //this.innerHTML = '<div class="block"> <span class="time">0</span> <span class="text">day</span> </div> <div class="block"> <span class="time">0</span> <span class="text">hour</span> </div> <div class="block"> <span class="time">0</span> <span class="text">min</span> </div> <div class="block"> <span class="time">0</span> <span class="text">sec</span> </div>';
        this.classList.add('hidden');
        const message = this.nextElementSibling;
        if(!message || !message.classList.contains('countdown-timer_message')) return;
        message.classList.remove('hidden');
        return;
      } else {
        const remainingTime = endDate.getTime() - Date.now();
        if (remainingTime <= 0) {
          this.innerHTML = `<div class="block"> <span class="time">0</span> <span class="text">${window.additionalStrings.countdown_days_label}</span> </div> <div class="block"> <span class="time">0</span> <span class="text">${window.additionalStrings.countdown_hours_label}</span> </div> <div class="block"> <span class="time">0</span> <span class="text">${window.additionalStrings.countdown_min_label}</span> </div> <div class="block"> <span class="time">0</span> <span class="text">${window.additionalStrings.countdown_sec_label}</span> </div>`;
        } else {
          this.remainingTime = remainingTime;
          this.innerHTML = this.getTimeString();
        }
      }
    }

    connectedCallback() {
      if (isNaN(this.remainingTime)) {
        this.classList.add('hidden');
        const message = this.nextElementSibling;
        if(!message || !message.classList.contains('countdown-timer_message')) return;
        message.classList.remove('hidden');
        return;
      }
      this.intervalId = setInterval(() => {
        this.remainingTime -= 1000;
        this.innerHTML = this.getTimeString();
        if (this.remainingTime <= 0) {
          clearInterval(this.intervalId);
          this.dispatchEvent(new Event('timeup'));
        }
      }, 1000);
    }

    getTimeString() {
      if (isNaN(this.remainingTime) || this.remainingTime <= 0) {
        //return '<div class="block"> <span class="time">0</span> <span class="text">days</span> </div> <div class="block"> <span class="time">0</span> <span class="text">hours</span> </div> <div class="block"> <span class="time">0</span> <span class="text">mins</span> </div> <div class="block"> <span class="time">0</span> <span class="text">secs</span> </div>';
        this.classList.add('hidden');
        const message = this.nextElementSibling;
        if(!message || !message.classList.contains('countdown-timer_message')) return;
        message.classList.remove('hidden');
        return;
      }
      const days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24));
      const hours = Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);
      return `<div class="block"> <span class="time">${days}</span> <span class="text">${window.additionalStrings.countdown_days_label}</span> </div> <div class="block"> <span class="time">${hours}</span> <span class="text">${window.additionalStrings.countdown_hours_label}</span> </div> <div class="block"> <span class="time">${minutes}</span> <span class="text">${window.additionalStrings.countdown_min_label}</span> </div> <div class="block"> <span class="time">${seconds}</span> <span class="text">${window.additionalStrings.countdown_sec_label}</span> </div>`;
    }
  });
}

if (!customElements.get('accordion-wrapper')) {
  customElements.define('accordion-wrapper', class AccordionWrapper extends HTMLElement {
    constructor() {
      super();
      
      this.toggle = this.querySelector('summary');
      if(this.toggle) this.toggle.addEventListener('click', this.accordion.bind(this));
    }
    
    accordion(event){
      if(this.dataset.behavior === 'open-close') this.setEventListners();
      if(this.toggle.parentElement.hasAttribute('open') && this.dataset.behavior !== 'open-close') this.keepOpen(event);
      if(!this.toggle.parentElement.hasAttribute('open')) this.closeOther();
    }
    
    closeOther(){
      const allRows = document.querySelectorAll(`#${this.dataset.parent} details`);
      allRows.forEach(toggler => {
        if(toggler.querySelector('summary') === this.toggle && this.dataset.behavior !== 'open-close') return;
        toggler.removeAttribute('open');
      });
    }
    
    keepOpen(event){
      const toggle = event.target.closest('details');
      toggle.removeAttribute('open');
    }
    
    setEventListners(){
      document.body.addEventListener('click', this.hideOutside.bind(this));
      this.addEventListener('keyup', this.onKeyUp.bind(this));
    }
    
    hideOutside(event){
      const target = event.target;
      const boundings = this.querySelector('.collapsible-row_content');
      if (boundings.contains(target) || target === boundings || target.closest('.collapsible-row_content')) return;
      this.closeOther();
    }

    onKeyUp(event){
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.closeOther();
    }
  });
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}
Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};
Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};
Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
function validation() {
  let email = document.querySelectorAll('[name="contact[email]"]');
  let pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
  email.forEach(input => {
    let text = input.closest('form').querySelector('.results-wrap_message');
    let button = input.closest('form').querySelector('[type="submit"]');
    if (input.value.match(pattern)) {
      if(text) text.innerHTML = window.accessibilityStrings.newsletterValidMessage;
      if(text) text.style.color = 'var(--section-success-color)';
      input.classList.remove('form-control--error');
      if(button) button.removeAttribute('disabled');
    } else {
      if(text) text.innerHTML = window.accessibilityStrings.newsletterInValidMessage;
      if(text) text.style.color = 'var(--section-error-color)';
      input.classList.add('form-control--error');
      if(button) button.setAttribute('disabled', '');
      if (event.keyCode == '13') {
        event.preventDefault();
      }
    }
  
    if (input.value == '') {
      if(text) text.innerHTML = "";
      if(text) text.style.color = 'var(--section-success-color)';
      input.classList.remove('form-control--error');
      if(button) button.setAttribute('disabled', '');
    }
  });
};
document.addEventListener('DOMContentLoaded', function(){
  const compareListStorage = localStorage.getItem('comparelist');
  const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
  if(!comparelistContainer) return;
  const comparelistOrganizer = document.querySelector('.compare-counter');
  const compareLimit = 3;
  let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
    
  if(compareList.length && compareList.length >= compareLimit){
    comparelistContainer.classList.add('--limit-exceed');
  
  } else{
    comparelistContainer.classList.remove('--limit-exceed');
  }
  
  if(comparelistOrganizer){
    comparelistOrganizer.innerText = compareList.length;
    const modalOpener = document.querySelector('[data-modal-main="compare"]');

    if(compareList.length === 0){
      modalOpener.classList.add('hidden');
    
    } else if(compareList.length === 1){
      modalOpener.classList.remove('hidden');
      modalOpener.classList.add('--disabled');
    
    } else{
      modalOpener.classList.remove('--disabled');
      modalOpener.classList.remove('hidden');
    }
  }
  
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const formType = url.searchParams.get('form_type');
  const msg = url.searchParams.get('contact[Message]');
  const contactPosted = url.searchParams.get('contact_posted');

  if (formType === 'contact' || contactPosted === 'true') {
    var hashIndex = currentUrl.indexOf('#');
    const popup = hashIndex !== -1 ? document.getElementById(currentUrl.slice(hashIndex + 1)).closest('modal-component') : document.querySelector('[data-modal="modal-question-ask"]');
    if(popup) popup.open();
  }
});
if (!customElements.get('sticky-block')) {
  customElements.define('sticky-block', class StickyBlock extends HTMLElement {
    constructor() {
      super();
      
      if(!this.dataset.refBlock && !this.dataset.behavior) return;
      this.onLoad = setTimeout(this.initialize.bind(this), 2000);
    }
    
    connectedCallback(){
      document.addEventListener('DOMContentLoaded', function(){this.onload;});
    }
    
    initialize(){
      this.behavior = this.dataset.behavior;
      this.spacer = this.dataset.spacer;
      this.endBounds = document.body.offsetHeight + this.offsetHeight;
      
      if(this.behavior){
        switch (this.behavior) {
          case 'downwards':
            window.addEventListener('scroll', this.onDownwardScroll.bind(this));
            break;
          case 'upwards':
            window.addEventListener('scroll', this.onUpwardScroll.bind(this));
            break;
          case 'stacked':
            window.addEventListener('scroll', this.onStackedScroll.bind(this));
            break;
          default:
            console.log('init sticky block');
            break;
        }
      }
      this.refBlock = document.querySelector(this.dataset.refBlock);
      if(!this.refBlock) return;
      
      this.refBoundings = this.refBlock.getBoundingClientRect();
      this.offset = this.dataset.offset ? parseFloat(this.dataset.offset) : 0;
      this.threshold = this.refBlock.offsetTop + this.refBoundings.height + this.offset;
      this.previousScrollAmount = window.screenY;
      this.percent = this.dataset.pagePercentage ? this.dataset.pagePercentage : null;
      
      if(this.spacer) this.height = this.refBlock.offsetHeight;
    }
    
    onDownwardScroll(){
      let revealedAttr = false;
      
      if(this.percent){
        const pageHeight = document.documentElement.offsetHeight;
        const threshold = pageHeight * parseFloat(this.percent) / 100;
        this.threshold = threshold;
      }
      
      if(window.scrollY > this.threshold){
        revealedAttr = true;
      }
      
      this.setStickyStatus(revealedAttr);
    }
    
    onUpwardScroll(){
      let revealedAttr = false;
      const threshold = this.height ? this.height : this.refBlock.offsetHeight;
      
      if (window.scrollY > this.previousScrollAmount) {
        revealedAttr = false;
        
      } else if (window.scrollY < this.previousScrollAmount) {
        revealedAttr = true;
        this.dropdownClose();
        
        if(window.scrollY < threshold){
          revealedAttr = false;
        }
      }
      
      this.setStickyStatus(revealedAttr);
      this.previousScrollAmount = window.scrollY;
    }
    
    onStackedScroll(){
      let revealedAttr = false;
      if(this.refBoundings.y < 0) this.refBoundings.y += window.scrollY;
      if(this.refBoundings.y < window.scrollY){
        revealedAttr = true;
      }
      
      this.setStickyStatus(revealedAttr);
    }
    
    setStickyStatus(revealed){
      if(this.dataset.hideOnEnd === 'true'){
        if((window.innerHeight + window.scrollY) >= this.endBounds){
          this.stickyHide();
          return;
        }
      }
      
      if(revealed){
        this.setAttribute('data-revealed', true);
        if(this.dataset.hasHidden === 'true') this.removeAttribute('aria-hidden');
        if(this.dataset.bodyClass) document.body.classList.add(this.dataset.bodyClass);
        if(this.height){
          this.style.height = this.height + 'px';
          if(this.dataset.bodyClass) document.body.style.setProperty(this.dataset.cssVariable, this.height + 'px');
        }
        return;
      }
      
      this.stickyHide();
    }
    
    stickyHide(){
      this.setAttribute('data-revealed', false);
      if(this.dataset.hasHidden === 'true') this.setAttribute('aria-hidden', true);
      if(this.dataset.bodyClass) document.body.classList.remove(this.dataset.bodyClass);
      if(this.height){
        this.style.removeProperty('height');
        
        if(this.dataset.bodyClass) document.body.style.removeProperty(this.dataset.cssVariable);
      }
    }
    
    dropdownClose(){
      const dropdowns = this.querySelectorAll('dropdown-component');
      if(!dropdowns) return;
      dropdowns.forEach(dropdown => {
        dropdown.close();
      });
    }
  });
}

if (!customElements.get('product-card-compare-remove')) {
  customElements.define('product-card-compare-remove', class ProductCardCompareRemove extends HTMLElement {
    constructor() {
      super();
      
      this.btn = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
      if(this.btn) this.btn.addEventListener('click', this.onCompareRemoval.bind(this));
    }
    
    onCompareRemoval(){
      event.preventDefault();
      
      const compareBtns = document.querySelectorAll('product-compare-button');
      const compareListStorage = localStorage.getItem('comparelist');
      const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
      const comparelistOrganizer = document.querySelector('.compare-counter');
      const modalCompare = document.querySelector('[data-modal][data-compare="true"]');
      let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
      var index = compareList.indexOf(this.dataset.handle);
      
      if (index !== -1) {
        compareList.splice(index, 1);
      }
      localStorage.setItem('comparelist', JSON.stringify(compareList));
      if(modalCompare) modalCompare.close();
      
      // const parentColumn = this.btn.closest('.compare-product');
      // if(parentColumn) parentColumn.parentElement.remove();
      
      if(comparelistContainer.classList.contains('--limit-exceed')) comparelistContainer.classList.remove('--limit-exceed');
      const modalOpener = document.querySelector('[data-modal-main="compare"]');
      if(compareList.length === 0){
        modalOpener.classList.add('hidden');
        const modal = document.querySelector('[data-modal="modal-compare-show"]');
        if(modal) modal.close();
      
      } else if(compareList.length === 1){
        modalOpener.classList.remove('hidden');
        modalOpener.classList.add('--disabled');
      
      } else{
        modalOpener.classList.remove('--disabled');
        modalOpener.classList.remove('hidden');
      }
      if(comparelistOrganizer){
        comparelistOrganizer.innerText = compareList.length;
      }
      if(compareBtns){
        compareBtns.forEach(btn => {
          if(btn.dataset.handle == this.dataset.handle && btn.anchor.classList.contains('--compare-active')) btn.anchor.classList.remove('--compare-active');
        });
      }
      if(compareList.length !== 0 && modalCompare) modalCompare.open();
    }
  });
}
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      
      this.bundleContainer = document.querySelector('[data-bundle-product-wrapper]');
      if(this.bundleContainer) this.bundleContainer.classList.add('visually-hidden');
    }

    connectedCallback() {
      this.empty = true;
      
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.empty = false;
              this.innerHTML = recommendations.innerHTML;
              
              if(!recommendations.innerHTML.includes('<product-card')){
                let recommendationAncestor = this.parentElement;
                
                while (recommendationAncestor && !recommendationAncestor.classList.contains('recommendation')) {
                  recommendationAncestor = recommendationAncestor.parentElement;
                }
                
                if(recommendationAncestor){
                  recommendationAncestor.classList.add('hidden');
                }
              }
            
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            if(this.empty){
              if(this.bundleContainer) this.bundleContainer.classList.add('hidden');
              this.parentElement.classList.add('hidden');
              return;
            }
            if(this.bundleContainer) this.bundleContainer.classList.remove('visually-hidden');
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  });
}

// marquee
if (!customElements.get('marquee-component')) {
  customElements.define('marquee-component', class MarqueeComponent extends HTMLElement {
    constructor() {
      super();

      if(this.dataset.pauseOnHover === 'true'){
        this.addEventListener('mouseenter', this.setOnPause.bind(this));
        this.addEventListener('mouseleave', this.setOnResume.bind(this));
      }
      
      this.onLoad = setTimeout(this.initialize.bind(this), 2000);
    }

    connectedCallback(){
      this.columnsCount = this.querySelectorAll('.marquee-component_col:not([class*="cloned"])').length;
      document.addEventListener('DOMContentLoaded', function(){this.onload;});
    }

    initialize(){
      this.init = null;
      this.initBounds = this.getColumnsSize() * 2;
      if(this.initBounds === 0) return;
      this.mainBounds = this.dataset.rotation ? this.getBoundingClientRect().height : this.getBoundingClientRect().width;
      this.createClones();
      this.dataset.direction === 'forward' ? this.setOnMarquee(this.initBounds * -1, this.initBounds) : this.setOnMarquee(0, this.initBounds);
    }

    setOnMarquee(pos, cycle){
      const speed = parseFloat(this.dataset.speed);
      let cycleCount = cycle;
      let container = this.querySelector('.marquee-component');
      clearInterval(this.init);
      this.init = setInterval(frame.bind(this), speed);

      function frame(){
        if(cycleCount <= 1){
          clearInterval(this.init);
          if(this.dataset.rotation){
            container.style.top = 0 + 'px';
          } else{
            container.style.left = 0 + 'px';
          }
          this.dataset.direction === 'forward' ? this.setOnMarquee(this.initBounds * -1, this.initBounds) : this.setOnMarquee(0, this.initBounds);
          this.pos = pos;
        
        } else{
          this.dataset.direction === 'forward' ? pos++ : pos--;
          cycleCount--;
          this.pos = pos;
          this.cycleCount = cycleCount;
          
          if(this.dataset.rotation){
            container.style.top = pos + 'px';
          } else{
            container.style.left = pos + 'px';
          }
        }
      }
    }

    setOnPause(){
      clearInterval(this.init);
    }

    setOnResume(){
      this.setOnMarquee(this.pos, this.cycleCount);
    }

    setContainer(size, container){
      if(this.dataset.rotation){
        container.style.height = size + 'px';
        container.style.top = (this.initBounds * -1) + 'px';
      } else{
        container.style.width = size + 'px';
        container.style.left = (this.initBounds * -1) + 'px';
      }
    }

    setTabIndexing(){
      const focusables = this.querySelectorAll('[class*="cloned"] a', '[class*="cloned"] button');
      focusables.forEach(element => {
        element.tabIndex = -1;
        element.setAttribute('aria-hidden', 'true');
      });
    }

    createClones(){
      const wrapper = this.querySelector('.marquee-component');
      this.sizes = this.getColumnsSize();
      if(this.sizes === 0) return;
      this.clone(wrapper);

      while(this.sizes < this.mainBounds){
        this.clone(wrapper);
        this.createClones();
      }
      this.setContainer(this.sizes, wrapper);
      this.setTabIndexing();
    }

    clone(wrapper){
      const columns = this.querySelectorAll('.marquee-component_col:not([class*="cloned"])');
      for(const column of columns){
        const clonedColumn = column.cloneNode(true);
        clonedColumn.classList.add('clonedBefore');
        wrapper.insertBefore(clonedColumn, columns[0]);
      }
      for(const column of columns){
        const clonedColumn = column.cloneNode(true);
        clonedColumn.classList.add('clonedAfter');
        wrapper.appendChild(clonedColumn);
      }
    }

    getColumnsSize(){
      let widths = 0;
      const columns = this.querySelectorAll('.marquee-component_col');
      columns.forEach(column => {
        const bounds = column.getBoundingClientRect();
        widths += this.dataset.rotation ? bounds.height : bounds.width;
      });

      return widths;
    }
  });
}

// button dropdown component
if (!customElements.get('dropdown-component')) {
  customElements.define('dropdown-component', class DropdownComponent extends HTMLElement {
    constructor() {
      super();
      
      if(this.dataset.desktopHidden === 'true' && screen.width > 767) return;
      this.button = this.querySelector('.dropdown-component_opener:not(.hidden)');
      this.content = this.querySelector('.dropdown-component_wrapper');
      this.onButtonClick = this.toggleDropdown.bind(this);
      this.shareEvent = this.copyToClipboard.bind(this);
      this.shareClose = this.close.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.button.addEventListener('click', this.onButtonClick);

      if(this.dataset.submission === 'true'){
        this.input = this.querySelector('input');
        const itemsArr = this.content.querySelectorAll('.dropdown-component_btn-submit');
        if(!itemsArr) return;
        itemsArr.forEach(item => {item.addEventListener('click', this.onItemClick.bind(this));});
      }
      
      if(this.dataset.sorting === 'true'){
        const itemsArr = this.content.querySelectorAll('.dropdown-component_btn-sort');
        if(!itemsArr) return;
        itemsArr.forEach(item => {item.addEventListener('click', this.onSort.bind(this));});
      }
      
      if(this.dataset.share === 'true'){
        this.elements = {
          successMessage: this.querySelector('.shareMessage'),
          closeButton: this.querySelector('.share-button__close'),
          shareButton: this.querySelector('.share-button__copy'),
          urlInput: this.querySelector('.shareUrl')
        }
        if(navigator.share){
          this.button.removeEventListener('click', this.onButtonClick);
          this.button.addEventListener('click', () => { navigator.share({ url: this.elements.urlInput.value, title: document.title }); });
          return;
        }
      }
      
      this.setIndexing(false);
    }

    toggleDetails(){
      if(!this.dataset.share) return;
      this.elements.successMessage.classList.add('hidden');
      this.elements.successMessage.textContent = '';
      this.elements.closeButton.classList.add('hidden');
    }

    copyToClipboard(){
      if(!this.dataset.share) return;
      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        this.elements.closeButton.classList.remove('hidden');
      });
      this.elements.closeButton.addEventListener('click', this.shareClose);
    }

    open(){
      this.button.setAttribute('aria-expanded', true);
      this.content.focus();
      this.content.classList.add('dropdown--open');
      const focusables = this.dataset.dropdownLevel === '2' ? this.querySelectorAll('a[data-level="2"],button[data-level="2"]') : this.querySelectorAll('a[data-level="1"],button[data-level="1"]');
      document.body.addEventListener('click', this.onBodyClick);
      this.addEventListener('keyup', this.onKeyUp);
      if(this.dataset.share === 'true'){
        if(!navigator.share){
          this.elements.shareButton.addEventListener('click', this.shareEvent);
        }
      }
      if(!focusables) return;
      this.setIndexing(true, focusables);
    }

    close(){
      if(!this.button) return;
      this.button.setAttribute('aria-expanded', false);
      this.content.classList.remove('dropdown--open');
      document.body.removeEventListener('click', this.onBodyClick);
      this.removeEventListener('keyup', this.onKeyUp);
      if(this.dataset.share === 'true'){
        if(navigator.share){
          this.elements.shareButton.removeEventListener('click', () => { navigator.share(); });
        
        } else{
          this.elements.shareButton.removeEventListener('click', this.shareEvent);
        }
        this.toggleDetails();
      }
      const focusables = this.dataset.dropdownLevel === '2' ? this.querySelectorAll('a[data-level="2"],button[data-level="2"]') : this.querySelectorAll('a[data-level="1"],button[data-level="1"]');
      if(!focusables) return;
      this.setIndexing(false, focusables);
    }

    toggleDropdown(event){
      if(event.target.getAttribute('aria-expanded') === 'true') return this.close();
      this.open();
    }

    onBodyClick(event){
      const target = event.target;
      if(this.contains(target) || target === this || target === this.button
        && this.button.getAttribute('aria-expanded') === 'true') return;
      
      if(this.dataset.dropdownLevel === '2'){
        event.stopPropagation();
        this.close();
        return;
      }

      this.close();
    }

    onKeyUp(event){
      if(event.code.toUpperCase() !== 'ESCAPE') return;
      
      if(this.dataset.dropdownLevel === '2'){
        event.stopPropagation();
        this.close();
        return;
      }
      this.close();
      this.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = document.getElementById(this.dataset.formId);
      if(this.input) this.input.value = event.currentTarget.dataset.value;
      if (this.input && form) form.submit();
    }
    
    onSort(event){
      event.preventDefault();
      const sortInput = document.getElementById(this.dataset.inputId);
      let form = document.querySelector('.filters-sidebar filters-form form');
      if(!form) form = document.querySelector('#filters-form');
      if(!sortInput || !form) return;
      const value = event.target.dataset.value;
      const text = event.target.firstChild.textContent;
      this.button.firstChild.textContent = text;
      sortInput.value = value;
      form.dispatchEvent(new Event('input'));
    }
    
    setIndexing(flag, arr = null){
      const focusables = arr ? arr : this.content.querySelectorAll('a[data-level],button[data-level]');
      if(!focusables) return;
      focusables.forEach(element => {
        indexing(flag, element);
      });
      
      function indexing(condition, element){
        if(condition){
          element.removeAttribute('tabindex');
        
        } else{
          element.setAttribute('tabindex', '-1');
        }
      }
    }
  });
}

// modal / drawer toggler
if (!customElements.get('modal-component-toggler')) {
  customElements.define('modal-component-toggler', class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      
      if(this.dataset.desktopHidden && screen.width > 991) return;
      if(this.dataset.mobileHidden && screen.width < 768) return;
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.toggleModal.bind(this));
    }

    open(modal){
      modal.open(this.button);
      this.button.setAttribute('data-expanded', 'true');
    }

    close(modal){
      modal.close();
    }

    toggleModal(event){
      event.preventDefault();

      if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
      const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
      if(this.button.dataset.expanded === 'true') return this.close(modal);
      this.open(modal);
    }
  });
}

// modal / drawer content component
if (!customElements.get('modal-component')) {
  customElements.define('modal-component', class ModalComponent extends HTMLElement {
    constructor() {
      super();
      
      if(this.dataset.desktopHidden && screen.width > 991) return;
      if(this.dataset.mobileHidden && screen.width < 768) return;
      if(this.dataset.storage === 'true'){
        const keyExists = localStorage.getItem(this.dataset.storageKey);
        if(keyExists === this.dataset.storageValue) return this.remove();
      }
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      
      if(this.dataset.compare === 'true'){
        this.elements = {
          counterElement: this.querySelector('.compare-counter'),
          contentBody: this.querySelector('.compare-popup_body'),
          contentGrid: this.querySelector('.compare-popup_grid'),
        }
      }

      if(this.dataset.trigger === 'self'){
        this.open();
      }
    }

    open(toggler = null){
      this.toggler = toggler;
      if(this.dataset.container === 'body'){
        this.parent = this.parentElement;
        document.body.append(this);
      }
      this.setClasses(true);
      if(this.dataset.compare === 'true'){
        this.onContentOpen();
      } else{
        this.content.focus();
        trapFocus(this.content);
      }
      if(!this.dataset.trigger || this.dataset.trigger !== 'self') this.setListeners(true);
    }

    close(){
      if(this.dataset.container === 'body'){
        if(this.parentNode === document.body) document.body.removeChild(this);
        if(this.parent) this.parent.append(this);
      }
      if(this.toggler) this.toggler.setAttribute('data-expanded', 'false');
      this.setClasses(false);
      if(this.toggler) removeTrapFocus(this.toggler);
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
      if(this.dataset.formReset === 'true'){
        const form = this.querySelector('form');
        if(form) form.reset();
      }
    }

    setClasses(flag){
      if(!flag){
        this.classList.remove('modal--active');
        document.body.classList.remove(`${this.dataset.modal}--modal-active`, 'overflow-hidden');
        return;
      }
      this.classList.add('modal--active');
      document.body.classList.add(`${this.dataset.modal}--modal-active`, 'overflow-hidden');
    }

    setListeners(flag){
      if(flag){
        this.addEventListener('keyup', this.onKeyUp);
        if(!this.dataset.compare) this.addEventListener('click', this.onBodyClick);
      
      } else{
        this.removeEventListener('keyup', this.onKeyUp);
        if(!this.dataset.compare) this.removeEventListener('click', this.onBodyClick);
      }
    }

    onBodyClick(event){
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (boundings.contains(target) || target === boundings) return;
      this.close();
    }

    onKeyUp(event){
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.close();
    }
    
    onContentOpen(){
      this.classList.remove('--loaded');
      this.elements.contentBody.classList.add('--show-loader');
      this.elements.contentGrid.innerHTML = '';
      const compareListStorage = localStorage.getItem('comparelist');
      const compareList = JSON.parse(compareListStorage);
      while (compareList.length < 3) {
        compareList.push('null');
      }
      this.initRenderProcess(compareList);
    }
    
    initRenderProcess(arr){
      if(arr.length){
        const columnCurr = arr[0];
        this.getCompareRender(columnCurr, arr);
        return;
      }
      this.setSameheightRows();
      
      this.elements.contentBody.classList.remove('--show-loader');
      this.classList.add('--loaded');
      this.content.focus();
      trapFocus(this.content);
    }
    
    getCompareRender(handle, all){
      fetch(`${this.dataset.url}products/${handle}?section_id=${this.dataset.sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const currHtml = html.querySelector('#compare-product-organizer > div');
          
          this.setAppendColumn(currHtml);
      })
      .finally(() => {
        this.setCurrentArr(all);
      });
    }
    
    setAppendColumn(html){
      this.elements.contentGrid.append(html);
    }
    
    setCurrentArr(norm){
      const nextColumnsArr = norm.slice(1);
      this.initRenderProcess(nextColumnsArr);
    }
    
    setSameheightRows(){
      const rows = this.querySelectorAll('.compare-product_row');
      let height = 0;
      
      for (let i = 0; i < rows.length; i++) {
        const elementHeight = rows[i].offsetHeight;
        
        if(elementHeight > height){
          height = elementHeight;
        }
      }
      
      for (let i = 0; i < rows.length; i++) {
        rows[i].style.setProperty('--cp-same-height', height + 'px');
      }
    }
  });
}

// tabset
if (!customElements.get('tabset-component')) {
  customElements.define('tabset-component', class TabsetComponent extends HTMLElement {
    constructor() {
      super();
      
      this.tablistNode = this;
      this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
      this.initialize();
      if(this.dataset.editorMode === 'true'){
        document.addEventListener('shopify:block:select', function (event) {
          const target = event.target;
          const parent = target.parentElement;
          if(parent.nodeName !== 'TABSET-COMPONENT') return;
          parent.initialize();
          parent.setSelectedTab(target);
        });
      }
    }
    
    initialize(){
      this.tabpanels = this.tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
      this.tabs.forEach(tab => {
        tab.tabIndex = -1;
        tab.setAttribute('aria-selected', 'false');
        tab.addEventListener('keydown', this.onKeydown.bind(this));
        tab.addEventListener('click', this.onClick.bind(this));
      });

      this.firstTab = this.tabs[0];
      this.lastTab = this.tabs[this.tabs.length - 1];
      this.setSelectedTab(this.firstTab, false);
    }

    setSelectedTab(currentTab, setFocus = true) {
      this.tabs.forEach((tab, index) => {
        const isSelected = currentTab === tab;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
        this.tabpanels[index].classList.toggle('hidden', !isSelected);
        if (isSelected && setFocus) {
          tab.focus();
        }
      });
    }

    setSelectedToPreviousTab(currentTab) {
      const index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(index === 0 ? this.lastTab : this.tabs[index - 1]);
    }

    setSelectedToNextTab(currentTab) {
      const index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(index === this.tabs.length - 1 ? this.firstTab : this.tabs[index + 1]);
    }

    onKeydown(event) {
      const tgt = event.currentTarget;
      let flag = false;

      switch (event.key) {
        case 'ArrowLeft':
          this.setSelectedToPreviousTab(tgt);
          flag = true;
          break;

        case 'ArrowRight':
          this.setSelectedToNextTab(tgt);
          flag = true;
          break;

        case 'Home':
          this.setSelectedTab(this.firstTab);
          flag = true;
          break;

        case 'End':
          this.setSelectedTab(this.lastTab);
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    onClick(event) {
      this.setSelectedTab(event.currentTarget);
    }
  });
}

if (!customElements.get('shipping-bar')) {
  customElements.define(
    'shipping-bar',
    class ShippingBar extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.setString();
        this.setBar();
      }

      setString() {
        // Keep original template once so replacements don’t cascade after updates
        if (!this._template) this._template = this.innerHTML;
        const html = this._template;

        // ✅ metafield-driven flag coming from Liquid: data-has-free-ship-item="true/false"
        const hasFreeShipItem = String(this.dataset.hasFreeShipItem) === 'true';

        // Detect active currency
        const active =
          window.Shopify?.currency?.active ||
          window.Shopify?.currency?.current ||
          document.documentElement.getAttribute('data-currency') ||
          'EUR';

        // Read threshold for active currency (major units)
        const map = {
          EUR: Number(this.dataset.thresholdEur),
          USD: Number(this.dataset.thresholdUsd),
          GBP: Number(this.dataset.thresholdGbp),
          CAD: Number(this.dataset.thresholdCad),
          CHF: Number(this.dataset.thresholdChf),
          AUD: Number(this.dataset.thresholdAud),
          NZD: Number(this.dataset.thresholdNzd),
          PLN: Number(this.dataset.thresholdPln),
        };

        const threshold =
          Number.isFinite(map[active]) && map[active] > 0
            ? map[active]
            : Number.isFinite(map.EUR)
              ? map.EUR
              : 0;

        // cartTotals is already in the ACTIVE currency (Shopify Markets presentment currency)
        const cartTotalsActive = Number(this.dataset.cartTotals) / 100;

        // If threshold missing/0, just bail safely
        if (!Number.isFinite(threshold) || threshold <= 0) {
          this.threshold = 0;
          this.cartTotals = 0;
          return;
        }

        const remainingCents = (threshold - cartTotalsActive) * 100;

        // ✅ If any item grants free shipping, force unlocked state
        const unlocked =
          hasFreeShipItem || !(Number.isFinite(remainingCents) && remainingCents > 0);

        this.classList.toggle('--unlocked', unlocked);

        if (!unlocked) {
          // Update amount in the original template, so we don't lose markup
          this.innerHTML = html.replace(
            /\|\|amount\|\|/g,
            Shopify.formatMoney(remainingCents, window.money_format)
          );
        } else {
          // Keep markup, only change subtitle text
          const subtitle = this.querySelector('.shipping-subtitle');
          if (subtitle) {
            subtitle.innerHTML =
              (window.cartStrings && window.cartStrings.shippingAmount) ||
              'Free shipping unlocked!';
          }
        }

        this.threshold = threshold;

        // For bar fill: if unlocked, pretend we hit threshold
        this.cartTotals = unlocked ? threshold : cartTotalsActive;
      }

      setBar() {
        const element = this.querySelector('[data-set="bar"]');
        if (!element) return;
        if (!this.threshold || this.threshold <= 0) return;

        let percent = (this.cartTotals / this.threshold) * 100;
        percent = Math.max(0, Math.min(100, percent));
        element.style.width = percent + '%';
      }
    }
  );
}


if (!customElements.get('checkout-min')) {
  customElements.define('checkout-min', class CheckoutMin extends HTMLElement {
    constructor() {
      super();
      this.checkout = this.onCheckout.bind(this);
    }

    connectedCallback(){
      this.form = this.closest('form');
      this.button = this.querySelector('button');
      if(!this.form || !this.button) return;
      if(this.dataset.minValue === isNaN || this.dataset.cartValue === isNaN) return;
      this.onCheck();
      this.initialize();
    }

    onCheck(){
      this.form.addEventListener('submit', this.checkout);
    }

    initialize(){
      const dataRate = Number(this.dataset.amount);
      const rateFactor = Shopify.currency.rate || 1;
      const amountCalc = dataRate * rateFactor;
      const cartTotals = Number(this.dataset.cartTotals) / 100;
      this.amount = (amountCalc - cartTotals) * 100;
      const element = this.querySelector('.cart-min-value p');
      if(this.amount > 0){
        this.setStatus(false);
        element.classList.remove('hidden');
        element.innerText = element.innerText.replace('[value]', Shopify.formatMoney((amountCalc * 100), window.money_format));
        return;
      }
      element.classList.add('hidden');
      this.setStatus(true);
    }

    onCheckout(event){
      if(this.amount > 0){
        event.preventDefault();
        alert(window.cartStrings.minOrderAlert);
        return;
      }
    }

    setStatus(flag){
      if(flag) return this.button.removeAttribute('disabled');
      this.button.setAttribute('disabled', '');
    }

    removeListener(){
      this.form.removeEventListener('submit', this.checkout);
    }
  });
}



const togglerLoader = (flag, selector) => {
  const loader = selector ? document.querySelector(selector) : document.querySelector('[data-loader]');
  if(!loader) return;
  if(flag) return loader.classList.remove('hidden');
  loader.classList.add('hidden');
}

const getJsonParse = (attrStr) => {
  let arr = [];
  const strArr = attrStr ? JSON.parse(attrStr) : null;
  if(!strArr) return arr = null;
  strArr.forEach(selector => arr.push(document.querySelector(selector)));
  return arr;
}

const sectionArrRender = (secArr, response) => {
  secArr.forEach(section => {
    const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
    section.selectors.forEach(selector => {
      const targetElement = document.querySelector(selector);
      const sourceElement = html.querySelector(selector);
      if (targetElement && sourceElement) {
        targetElement.outerHTML = sourceElement.outerHTML;
      }
    });
  });
}

const fetchAtc = (sections, config, element, loaderSelector) => {
  this.error = true;
  togglerLoader(true, loaderSelector);
  atcError(null, element, false);
  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if(!response.sections) return atcError(response, element, true);
      this.error = false;
      sectionArrRender(sections, response);
    })
    .catch((e) => {
      console.log(e);
      throw e;
    })
    .finally(() => {
      resetQty(element.dataset.form);
      togglerLoader(false, loaderSelector);
      if(!this.error){
        if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
        if(element.dataset.modal === 'true'){
          const drawerToggler = document.querySelector(element.dataset.modalRef);
          if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
        }
        if (element.recipientForm) element.recipientForm.resetRecipientForm();
      }
    }
  );
}

const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector, loaderSelector, checkBundle = false) => {
  const json = document.querySelector(jsonSelector);
  if(!json) return;
  const data = JSON.parse(json.textContent);
  const variants = data.variants;
  this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
  setStatuses(this.currentVariant, formsSelector, renders, parentSelector, checkBundle);
  if(!this.currentVariant) return;
  if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
  renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector, loaderSelector);
}

const setStatuses = (variant, formElems, renderElems, parentElem, checkBundle) => {
  const forms = getJsonParse(formElems);
  forms.forEach(form => {
    if(!form) return;
    const atcBtn = checkBundle ? form.querySelector('[data-bundle-toggler]') : form.querySelector('[name="add"]');
    if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
    toggleAvail(true, renderElems, parentElem);
    const input = form.querySelector('[name="id"]');
    input.value = variant.id;
    if(!atcBtn) return;
    const textContainer = atcBtn.querySelector('[data-atc-text]');
    if(variant.available){
      textContainer.innerText = textContainer.dataset.textAvail;
      atcBtn.removeAttribute('disabled');
      atcBtn.classList.remove('--disabled');
      return;
    }
    textContainer.innerText = textContainer.dataset.textSold;
    atcBtn.setAttribute('disabled', '');
    atcBtn.classList.add('--disabled');
  });
}

const toggleAvail = (flag, selectors, parent, btn) => {
  const arr = JSON.parse(selectors);
  const parentElem = document.querySelector(parent);
  arr.forEach(selector => {
    const element = parentElem.querySelector(selector);
    if(!element) return;
    flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
  });
  if(!btn) return;
  const textContainer = btn.querySelector('[data-atc-text]');
  textContainer.innerText = textContainer.dataset.textUnavail;
  btn.setAttribute('disabled', '');
}

const setGallery = (imageId, galleries, render, template) => {
  const arr = JSON.parse(galleries);
  if(!arr) return;
  if(render){
    const templateElem = document.querySelector(template);
    const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
    const imageContainer = document.querySelector(arr[0]);
    var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
    var newOpacity = (currentOpacity === 1) ? 0 : 1;
    imageContainer.style.transition = 'opacity 0.3s ease';
    imageContainer.style.opacity = newOpacity;
    imageContainer.classList.remove('.imageContainer');
    setTimeout(() => {
      imageContainer.innerHTML = templateElement.outerHTML;
      setTimeout(() => {
        imageContainer.style.opacity = 1;
      }, 0);
    }, 500);
    return
  }
  arr.forEach(gallery => {
    const gal = document.querySelector(gallery);
    if(!gal) return;
    switch(gal.slider) {
      case undefined:
        let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
        const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
        if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
        items.unshift(items.splice(activeIndex, 1)[0]);
        gal.innerHTML = '';
        gal.classList.add('--swapped');
        gal.append(...items);
        break;
      default:
        const splide = gal.slider;
        const slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
        splide.go(slide[0].index);
        break;
    }
  });
}

const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector, loaderSelector) => {
  togglerLoader(true, loaderSelector);
  fetch(`${url}?variant=${id}&section_id=${section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const parentElement = document.querySelector(parent);
      const arr = JSON.parse(elems);
      arr.forEach(selector => {
        const element = parentElement.querySelector(selector);
        if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
      });
    })
    .catch((e) => {
      console.error(e);
      throw e;
    })
    .finally(() => {
      if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
      if(focusSelector){
        const focusParent = document.querySelector(focusSelector);
        trapFocus(focusParent.content ? focusParent.content : focusParent);
      }
      togglerLoader(false, loaderSelector);
    }
  );
}

const resetQty = (elem) => {
  const form = document.querySelector(elem);
  if(!form) return;
  const qtyField = form.quantity;
  qtyField.value = parseFloat(qtyField.min);
  qtyField.dispatchEvent(new Event('input'));
}

const atcError = (response, elem, flag) => {
  const errElem = document.querySelector(elem.dataset.errorSelector);
  const errSpan = errElem.querySelector('[data-error]');
  const recepForm = elem.form.querySelector('recipient-form');
  if(!flag){
    errElem.classList.add('hidden');
    errSpan.innerText = '';
    if(recepForm) recepForm.clearErrorMessage();
    return;
  }
  if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
  if(typeof response.description !== 'object'){
    errElem.classList.remove('hidden');
    errSpan.innerText = response.description;
  }
  resetQty(elem.dataset.form);
}

class VariantPill extends HTMLElement {
  constructor() {
    super();
  
    this.variantChange = this.onInputChange.bind(this);
    this.addEventListener('change', this.variantChange);
  }
  
  onInputChange(){
    const input = this.querySelector('input[type="radio"]:checked');
    this.setVariantOptions(input.value);
  }
  
  setVariantOptions(value){
    const parent = document.querySelector(this.dataset.parent);
    const mainParent = document.querySelector(this.dataset.mainParent);
    const errElem = document.querySelector(this.dataset.errorSelector);
    if(!parent) return;
    if(mainParent.hasAttribute('data-bundle-included')){
      const bundleCalculator = document.querySelector('bundle-calculator');
      mainParent.removeAttribute('data-bundle-included');
      bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
    }
    if(errElem) errElem.classList.add('hidden');
    const currentSet = JSON.parse(this.dataset.currentSet);
    const index = parseInt(this.dataset.optionIndex);
    currentSet[index] = value;
    const pills = parent.querySelectorAll('variant-pill');
    pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
    this.setOptions(pills, currentSet);
    let availableSet = null;
    if(this.dataset.checkSets === 'true'){
      const sets = JSON.parse(this.dataset.availableSets);
      const checkSet = (val) => {
        if (!val || !Array.isArray(sets)) return null;
        return sets.find(set => set.includes(val));
      };
      availableSet = checkSet(value);
    }
    onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null, this.dataset.loader ? this.dataset.loader : null, this.dataset.bundle === 'true' ? true : false);
  }
  
  setOptions(elems, set){
    const json = document.querySelector(this.dataset.jsonSelector);
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
    elems.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
      const previousOptionSelected = elems[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setAvailability(optionInputs, availableOptionInputsValue);
    });
  }
  
  setAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(elem => {
      const label = elem.nextElementSibling;
      const labelText = label.querySelector('[data-variant-status-text]');
      if (listOfAvailableOptions.includes(elem.getAttribute('value'))){
        elem.classList.remove('disabled');
        labelText.classList.add('hidden'), labelText.classList.remove('visually-hidden');
        return;
      }
      elem.classList.add('disabled');
      labelText.classList.remove('hidden'), labelText.classList.add('visually-hidden');
    });
  }
}
if(!customElements.get('variant-pill')) customElements.define('variant-pill', VariantPill);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
  
    const onButtonClick = (event) => {
      event.preventDefault();
      const previousValue = this.input.value;
      (event.target.name === 'plus' || event.target.parentElement.name === 'plus') ? this.input.stepUp() : this.input.stepDown();
      if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  
    const setBtnStatus = (type, value) => {
      const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
      const btn = type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
      switch (type) {
        case 'min':
          btn.classList.toggle('disabled', value <= currVal);
          btn.toggleAttribute('disabled', value <= currVal);
          break;
        case 'max':
          btn.classList.toggle('disabled', value >= currVal);
          btn.toggleAttribute('disabled', value >= currVal);
          break;
        default:
          console.log('no button found');
          break;
      }
    }
  
    const setSubtotals = (qty, elem) => {
      const total = qty * parseInt(this.dataset.variantPrice);
      elem.innerHTML = Shopify.formatMoney(total, window.money_format);
    }
  
    const onInputChange = () => {
      const value = parseInt(this.input.value);
      const qtySubtotal = this.querySelector('[data-qty-subtotal]');
      (this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value));
      if(!qtySubtotal) return;
      setSubtotals(value, qtySubtotal);
    }
  
    const setListeners = () => {
      this.changeEvent = new Event('input', { bubbles: true });
      this.inputChange = onInputChange.bind(this);
      this.buttonClick = onButtonClick.bind(this);
      this.input.addEventListener('input', this.inputChange);
      this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.buttonClick));
    }
  
    const initialize = () => {
      this.input = this.querySelector('input');
      if(!this.input) return;
      setListeners();
    }
    initialize();
  }
}
if(!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

class AtcSubmit extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.form = document.querySelector(this.dataset.form);
    if(!this.form) return;
    this.recipientForm = this.form.querySelector('recipient-form');
    this.submit = this.onAddToCart.bind(this);
    this.form.addEventListener('submit', this.submit);
  }

  onAddToCart(event){
    event.preventDefault();
    this.error = false;
    const secArr = JSON.parse(this.dataset.sections);
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData(this.form);
    formData.append('sections', secArr.map(section => section.id));
    formData.append('sections_url', window.location.pathname);
    config.body = formData;
    fetchAtc(secArr, config, this, this.dataset.loader);
  }
}
if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);

class AtcBundleToggler extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.form = document.querySelector(this.dataset.form);
    if(!this.form) return;
    const onBundleSubmit = (event) => {
      event.preventDefault();
      const parent = document.querySelector(this.dataset.mainParent);
      const btnSpan = parent.querySelector('[data-atc-text]');
      const formData = new FormData(this.form);
      const mediaElement = document.querySelector(this.dataset.gallery);
      const bundleCalculator = document.querySelector('bundle-calculator');
      bundleCalculator.init(mediaElement, parseInt(formData.get('id')), formData.get('variant_price'), formData.get('variant_compare_price'));
      if(!parent.hasAttribute('data-bundle-included')){
        btnSpan.innerText = btnSpan.dataset.removeText;
        parent.setAttribute('data-bundle-included', '');
        parent.setAttribute('data-bundle-variant', parseInt(formData.get('id')));
      } else{
        btnSpan.innerText = btnSpan.dataset.textAvail;
        parent.removeAttribute('data-bundle-included');
        parent.removeAttribute('data-bundle-variant');
      }
    };
    this.form.addEventListener('submit', onBundleSubmit);
  }

  onRemoval(){
    const parent = document.querySelector(this.dataset.mainParent);
    const btnSpan = parent.querySelector('[data-atc-text]');
    btnSpan.innerText = btnSpan.dataset.textAvail;
    parent.removeAttribute('data-bundle-included');
    parent.removeAttribute('data-bundle-variant');
  }
}
if(!customElements.get('atc-bundle-toggler')) customElements.define('atc-bundle-toggler', AtcBundleToggler);

class BundleCalculator extends HTMLElement {
  constructor() {
    super();

    this.arr = [];
    this.list = this.querySelector('[data-thumbnails-list]');
    this.btn = this.querySelector('[data-bundle-atc-btn]');
    if(this.btn) this.btn.addEventListener('click', this.onBundleSubmit.bind(this));
  }
  
  init(media, variant, price, comparePrice, removeId = null){
    const createDataset = (id, price, comparePrice, media) => {
      const index = this.arr.findIndex(item => item.variant === id);
      if(index === -1) return this.arr.push({ variant: id, media: media, price: parseInt(price), comparePrice: parseInt(comparePrice) });
      this.arr.splice(index, 1);
    }
    const updateStats = (price, comparePrice, count) => {
      const bundleNumElement = this.querySelector('[data-num-count]');
      const bundlePriceElement = this.querySelector('[data-bundle-price]');
      const bundleComparePriceElement = this.querySelector('[data-bundle-compare-price]');
      const bundleAtcBtn = this.querySelector('[data-bundle-atc-btn]');
      bundlePriceElement.innerText = Shopify.formatMoney(price, window.money_format);
      if(comparePrice === price){
        bundleComparePriceElement.classList.add('hidden');
      } else{
        bundleComparePriceElement.innerText = Shopify.formatMoney(comparePrice, window.money_format);
        bundleComparePriceElement.classList.remove('hidden');
      }
      if(count === 0){
        bundleNumElement.classList.add('hidden');
        bundleAtcBtn.classList.add('disabled');
        return;
      }
      bundleNumElement.innerText = count;
      bundleNumElement.classList.remove('hidden');
      bundleAtcBtn.classList.remove('disabled');
    }
    const renderDataList = () => {
      let bundlePrice = 0;
      let bundleComparePrice = 0;
      this.resetThumbsList();
      this.arr.forEach(product => {
        const thumbItem = document.createElement("li");
        this.list.appendChild(thumbItem);
        if(product.media) thumbItem.style.backgroundImage = `url('${product.media.src}')`;
        this.list.appendChild(thumbItem);
        bundlePrice += product.price;
        bundleComparePrice += product.comparePrice !== 0 ? product.comparePrice : product.price;
      });
      updateStats(bundlePrice, bundleComparePrice, this.arr.length);
    }
    if(removeId){
      const index = this.arr.findIndex(item => item.variant === removeId);
      this.arr.splice(index, 1);
      renderDataList();
      return;
    }
    createDataset(variant, price, comparePrice, media);
    renderDataList();
  }

  resetThumbsList(){
    while(this.list.firstChild){
      this.list.removeChild(this.list.firstChild);
    }
  }

  onBundleSubmit(event){
    event.preventDefault();
    const runAtc = () => {
      togglerLoader(true, this.dataset.loaderSelector);
      if(this.arr.length > 0){
        const product = this.arr[0];
        fetchBundleAtc(product);
        return;
      }
      togglerLoader(false, this.dataset.loaderSelector);
      if(this.dataset.redirect) return window.location.href = this.dataset.redirect;
      if(this.dataset.modal === 'true'){
        const drawerToggler = document.querySelector(this.dataset.modalRef);
        if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
      }
    }
    const fetchBundleAtc = (product) => {
      const secArr = JSON.parse(this.dataset.sections);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData();
      formData.append('sections', secArr.map(section => section.id));
      formData.append('sections_url', window.location.pathname);
      formData.append('id', product.variant);
      formData.append('quantity', 1);
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        sectionArrRender(secArr, response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        const parentCard = document.querySelector(`[data-bundle-included][data-bundle-variant="${product.variant}"]`);
        const toggler = parentCard.querySelector('atc-bundle-toggler');
        toggler.onRemoval();
        this.init(null, null, null, null, product.variant);
        runAtc();
      });
    }
    runAtc();
  }
}
if(!customElements.get('bundle-calculator')) customElements.define('bundle-calculator', BundleCalculator);

const lineItemUpdate = (line, quantity, sections, parent) => {
  togglerLoader(true);
  const secArr = JSON.parse(sections);
  var body = JSON.stringify({
    line,
    quantity,
    sections: secArr.map(section => section.id),
    sections_url: window.location.pathname
  });
  this.erorr = false;
  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((responseText) => {
      const response = JSON.parse(responseText);
      if(response.errors) return handleLineError(parent, response);
      sectionArrRender(secArr, response);
    }).catch((e) => {
      console.error(e);
    })
    .finally(() => {
      if(!this.erorr){
        const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
        if(modal){
          if(modal.classList.contains('modal--active')){
            trapFocus(modal.content);
            modal.setListeners(true);
          }
        }
      }
      togglerLoader(false);
    }
  );
}

class LineItemQty extends QuantityInput {
  constructor() {
    super();
  }
  
  connectedCallback(){
    this.inputUpdate = this.querySelector('[name="updates[]"]');
    this.debouncedOnUpdate = debounce((event) => {
      this.onLineItemUpdate(event);
    }, 500);
    this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
  }
  
  onLineItemUpdate(){
    const qty = parseInt(this.querySelector('[name="updates[]"]').value);
    lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
  }
}
if(!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);

class LineItemRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
  }

  connectedCallback(){
    if(!this.button) return;

    const onRemoval = (event) => {
      event.preventDefault();
      lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector)
    }
    this.removal = onRemoval.bind(this);
    this.button.addEventListener('click', this.removal);
  }
}
if(!customElements.get('line-item-remove')) customElements.define('line-item-remove', LineItemRemoveButton);

class DropdownToggler extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.button = this.querySelector('[data-btn-toggler]');
    if(!this.button) return;
    const onHandleClick = (event) => {
      event.preventDefault();
      const parent = document.querySelector(this.dataset.parent);
      parent.classList.toggle(this.dataset.activeClass);
    }
    this.handleClick = onHandleClick.bind(this);
    this.button.addEventListener('click', this.handleClick);
  }
}
if(!customElements.get('dropdown-toggler')) customElements.define('dropdown-toggler', DropdownToggler);




/*
  function applyOnce() {
    const builder = document.querySelector("#product-builder");
    if (!builder) return false;

    const totalEl = builder.querySelector(
      '.cpb-product-full-price [data-testid="multycurrency-price"]'
    );
    if (!totalEl) return false;

    const totalTxt = (totalEl.textContent || "").trim();
    const baseActive = parseMoney(totalTxt);

    if (baseActive == null || baseActive <= 0) {
      console.log("[CPB] baseActive not ready yet:", totalTxt);
      return false;
    }

    const currencyCode = getActiveCurrencyCode();
    const symbol = getActiveSymbolFromText(totalTxt);

    const rate = baseActive / BASE_EUR;
    if (!Number.isFinite(rate) || rate <= 0) {
      console.log("[CPB] invalid rate", { baseActive, BASE_EUR, totalTxt });
      return false;
    }

    const priceSpans = builder.querySelectorAll(
      '.cpb-option-info-price [data-testid="multycurrency-price"]'
    );

    if (!priceSpans.length) {
      console.log("[CPB] no option price spans found yet");
      return false;
    }

    let convertedCount = 0;

    priceSpans.forEach((span) => {
      const raw = (span.textContent || "").trim();

      // ✅ only cache when we can parse a real number
      if (!span.dataset.cpbEur) {
        const eur = parseMoney(raw);
        if (eur == null || eur <= 0) return; // don't cache junk
        span.dataset.cpbEur = String(eur);
      }

      const eurVal = Number(span.dataset.cpbEur);
      if (!Number.isFinite(eurVal) || eurVal <= 0) return;

      const converted = eurVal * rate;

      const intl = formatWithIntl(converted, currencyCode);
      span.textContent = intl ? intl : `${symbol}${converted.toFixed(2)}`;
      convertedCount++;
    });

    if (convertedCount === 0) {
      console.log("[CPB] nothing converted yet (labels maybe not rendered/parsable)");
      return false;
    }

    window.__cpb_labels_converted_once = true;
    console.log("[CPB] ✅ Converted once", {
      rate,
      baseActive,
      BASE_EUR,
      currency: currencyCode || symbol,
      convertedCount
    });

    return true;
  }

  let tries = 0;
  const timer = setInterval(() => {
    tries++;
    if (applyOnce() || tries >= 60) clearInterval(timer);
  }, 200);
})();

*/




(function () {
  'use strict';

  const BASE_TOTAL_EUR = 147; // <-- CHANGE THIS

  const BUILDER = '#product-builder';
  const PRICE_SPAN = '[data-testid="multycurrency-price"]';
  const OPTION_PRICE_SELECTOR = '.cpb-option-info-price ' + PRICE_SPAN;

  // -----------------------
  // Helpers
  // -----------------------
  function parseMoney(text) {
    const t = (text || '').trim();
    const cleaned = t.replace(/[^\d.,]/g, '');

    const lastDot = cleaned.lastIndexOf('.');
    const lastComma = cleaned.lastIndexOf(',');
    let normalized = cleaned;

    if (lastDot !== -1 && lastComma !== -1) {
      if (lastDot > lastComma) normalized = cleaned.replace(/,/g, '');
      else normalized = cleaned.replace(/\./g, '').replace(/,/g, '.');
    } else if (lastComma !== -1 && lastDot === -1) {
      normalized = cleaned.replace(/,/g, '.');
    }

    const num = parseFloat(normalized);
    return Number.isFinite(num) ? num : 0;
  }

  function getCurrencyCode() {
    return window.Shopify?.currency?.active || window.Shopify?.currency?.current || 'USD';
  }

  // Labels: ROUND to whole number
  function formatRounded(amount, currencyCode) {
    const n = Math.round(amount);
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(n);
    } catch {
      return String(n);
    }
  }

  // Total (and any CPB price): remove trailing ".42" or ",42"
  function stripTrailing2Decimals(text) {
    return (text || '').replace(/([.,]\d{2})(?=\s*$)/, '');
  }

  // -----------------------
  // Rate lock (ONLY from displayed TOTAL / BASE_TOTAL_EUR)
  // We take the FIRST plausible "big" price span in the builder as total anchor.
  // -----------------------
  let LOCKED_RATE = null;
  let LOCKED_CURRENCY = null;

  function findTotalAnchor(root) {
    // Prefer a typical CPB total container if present
    const preferred =
      root.querySelector('.cpb-product-full-price ' + PRICE_SPAN) ||
      root.querySelector('.cpb-product-total ' + PRICE_SPAN);

    if (preferred) return preferred;

    // Fallback: choose the largest numeric value among all price spans (very often the total)
    const spans = Array.from(root.querySelectorAll(PRICE_SPAN));
    let best = null;
    let bestVal = -1;

    spans.forEach((el) => {
      const v = parseMoney(el.textContent);
      if (v > bestVal) {
        bestVal = v;
        best = el;
      }
    });

    return best;
  }

  function computeRateFromTotal(root) {
    const totalEl = findTotalAnchor(root);
    if (!totalEl) return null;

    const shownTotal = parseMoney(totalEl.textContent);
    if (!shownTotal || shownTotal <= 0) return null;

    if (!Number.isFinite(BASE_TOTAL_EUR) || BASE_TOTAL_EUR <= 0) return null;

    const rate = shownTotal / BASE_TOTAL_EUR;
    return (Number.isFinite(rate) && rate > 0) ? rate : null;
  }

  function clearOptionBaseCache(root) {
    root.querySelectorAll(OPTION_PRICE_SELECTOR).forEach(el => delete el.dataset.baseEur);
  }

  function lockRate(root) {
    const currency = getCurrencyCode();

    if (LOCKED_CURRENCY && LOCKED_CURRENCY !== currency) {
      LOCKED_RATE = null;
      clearOptionBaseCache(root);
    }
    LOCKED_CURRENCY = currency;

    if (LOCKED_RATE && Number.isFinite(LOCKED_RATE) && LOCKED_RATE > 0) return LOCKED_RATE;

    const rate = computeRateFromTotal(root);
    if (!rate) return null;

    LOCKED_RATE = rate;
    return LOCKED_RATE;
  }

  // -----------------------
  // 1) Convert option labels (EUR -> active, rounded)
  // -----------------------
  function convertOptionLabels(root) {
    const rate = lockRate(root);
    if (!rate) return;

    const currency = getCurrencyCode();

    root.querySelectorAll(OPTION_PRICE_SELECTOR).forEach((el) => {
      // cache EUR base from label once
      if (!el.dataset.baseEur) {
        const eur = parseMoney(el.textContent);
        if (eur > 0) el.dataset.baseEur = String(eur);
      }

      const baseEur = parseFloat(el.dataset.baseEur);
      if (!Number.isFinite(baseEur) || baseEur <= 0) return;

      const converted = baseEur * rate;
      el.textContent = formatRounded(converted, currency);
    });
  }

  // -----------------------
  // 2) Truncate decimals for ALL CPB price spans (this is why it worked before)
  // -----------------------
  function truncateAllPrices(root) {
    root.querySelectorAll(PRICE_SPAN).forEach((el) => {
      const curr = (el.textContent || '').trim();
      const next = stripTrailing2Decimals(curr);
      if (curr !== next) el.textContent = next;
    });
  }

  function updateAll() {
    const root = document.querySelector(BUILDER);
    if (!root) return;

    // Convert labels first, then truncate decimals everywhere (total included)
    convertOptionLabels(root);
    truncateAllPrices(root);

    // Run again shortly after to beat late CPB renders
    setTimeout(() => {
      const r = document.querySelector(BUILDER);
      if (r) truncateAllPrices(r);
    }, 150);
  }

  // -----------------------
  // Observer-safe scheduling
  // -----------------------
  let obs;
  let running = false;

  function scheduleUpdate(delay = 80) {
    clearTimeout(window.__cpbTO);
    window.__cpbTO = setTimeout(() => {
      const root = document.querySelector(BUILDER);
      if (!root) return;

      if (running) return;
      running = true;

      if (obs) obs.disconnect();
      try {
        updateAll();
      } finally {
        if (obs) obs.observe(root, { childList: true, subtree: true, characterData: true });
        running = false;
      }
    }, delay);
  }

  function init() {
    const root = document.querySelector(BUILDER);
    if (!root) return;

    scheduleUpdate(300);
    scheduleUpdate(900);

    obs = new MutationObserver(() => scheduleUpdate(80));
    obs.observe(root, { childList: true, subtree: true, characterData: true });

    document.addEventListener('shopify:section:load', () => {
      const r = document.querySelector(BUILDER);
      if (r) {
        LOCKED_RATE = null;
        LOCKED_CURRENCY = null;
        clearOptionBaseCache(r);
      }
      scheduleUpdate(300);
      scheduleUpdate(900);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();









